module.exports = __webpack_public_path__ + "static/media/fast.d88cfd7f.svg";